<div hisDdKey="fs.res.patent.PriorityPatent.orgunits" #dDOrg>
    <his-plam class="noPlamStyle">
		<!-- organizations of patent are only editable within priority patent -->
		<res-organizations-panel #content 
            hisDdKey="fs.res.patent.PriorityPatent.orgunits"
            [ngModel]="{ internalOrganizations: this.internalOrganizations, externalOrganizations: this.externalOrganizations }"
			[dynamicComponent]="dynamicComponent"
			[showCreateLink]="true"
			[editMode]="isPriorityPatent"
			[header]="dDOrg.ddLabeltext"
			noAssignedMessage="fs.res.patent.noRegisteringOrganizationAssigned"
			[ddKey]="dDOrg.ddIdentifier"
			assignLink="fs.res.patent.addRegisteringOrganization" 
			(internalOrganizationsChange)="internalOrganizationsChange($event)"
			(deleteInternalOrganizationChange)="deleteOrganizationChange($event)"
			(externalOrganizationsChange)="externalOrganizationsChange($event)"
			(deleteExternalOrganizationChange)="deleteOrganizationChange($event)">
		</res-organizations-panel>
	</his-plam>
</div>
